<template>

  <v-container fluid grid-list-xl>

    <v-divider></v-divider>
        <v-container grid-list-xs>
            <template>
                <v-toolbar flat color="white">
                    
                    <v-toolbar-title>
                    <v-text-field 
                        disabled
                        v-model="this.$store.getters.get_date_branch_order"  
                        label="Delivery Date"
                        required                        
                    ></v-text-field>
                    </v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn class="font-weight-light" tile color="black" dark  @click="btn_add"  >
                        <v-icon >add</v-icon>
                    </v-btn>
                </v-toolbar>
            </template>
        </v-container>

        <v-dialog v-model="dialog" max-width="290">
            <v-card>
                <v-date-picker v-model="date"></v-date-picker>
                <v-spacer></v-spacer>
                    <v-btn block  @click="hide_dialog()" color="primary">Select</v-btn>
                    <v-btn block @click="hide_clear_dialog()" >Clear</v-btn>
            </v-card>
        </v-dialog>
    
        <v-dialog v-model="dialog_s" width="450" >
            <v-card>
                <v-card-title class="headline">Select Product</v-card-title>
                    <v-container>    
                        <v-text-field
                            v-model="searchQuery"
                            append-icon="mdi-magnify"
                            label="Search"
                            single-line
                            hide-details
                        ></v-text-field>
                        <v-divider></v-divider>
                        <br>
                        <table width="100%">
                            <tr v-for="item in resultQuery" :key="item.code" @click="show_qty_input( item.code , item.name , item.price )"  >            
                                <td width="20%"><h4 class="font-weight-light">{{item.code}}</h4></td>
                                <td width="80%"><h4 class="font-weight-light">{{item.name}}</h4></td> 
                                <td width="80%"><h4 class="font-weight-light">{{item.Addon}}</h4></td> 
                            </tr>
                        </table>                                
                    </v-container>
            </v-card>
        </v-dialog>

        <v-dialog v-model="dialog_menu" width="600" >
            <v-card>
                <v-card-title class="headline">Weekly Menu</v-card-title>
                    <v-container>    
                        <table width="100%" border="1">
                            <tr v-for="item in items_m" :key="item.date">            
                                <td width="25%"><center><h4 class="font-weight-light">{{item.date}}</h4></center></td>
                                <td>
                                    <table>
                                        <tr v-for=" (n ,index) in item.order" :key = "index" @click="show_qty_input_menu( item.date ,n.code , n.name , n.price , n.freeitem )" >
                                            <td><h4 class="font-weight-light">{{n.code}}</h4></td>
                                            <td><h4 class="font-weight-light">{{n.name}}</h4></td> 
                                            <td><h5 v-if="n.freeitem=='1'" class="font-weight-light">(Free Item)</h5></td> 
                                        </tr>
                                    </table>
                                </td>
                            </tr>
                            <v-divi></v-divi>
                        </table>                                
                    </v-container>
            </v-card>
        </v-dialog>      

        <v-dialog v-model="dialog_addon" width="450" >
            <v-card>
                <v-card-title class="headline">Addon Item</v-card-title>
                    <v-container>    
                        <table width="100%" >
                            <tr v-for="item in data_addon" :key="item.code" @click="show_qty_input_addon( item.code , item.name , item.price)" >            
                                <td width="15%"><h4 class="font-weight-light">{{item.code}}</h4></td>
                                <td width="70%"><h4 class="font-weight-light">{{item.name}}</h4></td>
                                <td width="20%"><h4 align="right" class="font-weight-light">{{item.price}}</h4></td>
                            </tr>
                            <v-divi></v-divi>
                        </table>                                
                    </v-container>
            </v-card>
        </v-dialog>    

        <v-dialog v-model="dialog_qty" width="370" >
            <v-card>
                <v-card-title class="headline">Sale QTY</v-card-title>
                    <v-container> 
                        <h5>{{add_item_code}} {{add_item_name}} Price {{add_item_price}} THB.</h5>   
                        <br>
                        <v-btn @click="saveItem(add_item_code , add_item_name , 1 , add_item_price)" >1</v-btn>
                        <v-btn @click="saveItem(add_item_code , add_item_name , 2 , add_item_price)" >2</v-btn>  
                        <v-btn @click="saveItem(add_item_code , add_item_name , 3 , add_item_price)" >3</v-btn>     
                        <br> 
                        <v-btn @click="saveItem(add_item_code ,add_item_name , 4 , add_item_price)" >4</v-btn>
                        <v-btn @click="saveItem(add_item_code ,add_item_name , 5 , add_item_price)" >5</v-btn>  
                        <v-btn @click="saveItem(add_item_code ,add_item_name , 6 , add_item_price)" >6</v-btn>    
                        <br> 
                        <div class="text-center my-3">
                            <v-text-field v-model="qty_add" label="Qty" 
                             ></v-text-field>    
                            <v-btn @click="saveItem(add_item_code ,add_item_name , qty_add , add_item_price)"  >Submit</v-btn>        
                        </div>
                    </v-container>
            </v-card>
        </v-dialog>

        <v-container grid-list-xs>
            <v-data-table
                class="table"
                :headers="headers"
                :items="users"
                :search="search"
                :rows-per-page-items="[10, 25]">
                <template slot="items" slot-scope="props">
                <td class="text-xs-left">{{ props.item.date }}</td>                   
                <td class="text-xs-left">{{ props.item.code }}</td>
                <td class="text-xs-left">{{ props.item.name }}</td>
                <td class="text-xs-left">                    
                    <span class="material-icons" @click="update_item(props.item.code , 0 )" >remove</span>
                </td>
                <td class="text-xs-center">{{ props.item.qty }}</td>
                <td class="text-xs-left">                    
                    <span class="material-icons"  @click="update_item(props.item.code , 1 )">add</span>
                </td>        
                <td class="text-xs-center">
                    <v-icon class="mr-2" @click="del_prod(props.item.code )">delete</v-icon>
                </td>
                </template>
            </v-data-table>
        </v-container>
      
        <v-container grid-list-xs>
            <v-layout row wrap>
                <v-flex md6>
                    
                </v-flex>

            </v-layout>
            
                <center><v-btn @click="save_order()">Save Order</v-btn></center>

        </v-container>
    </v-container>
    
</template>

<script>
export default {
  data() {
    return {
        
        date: new Date().toISOString().substr(0, 10),
        date_menu : '',
        data_addon :'',
        menu: false,
        dialog : false,
        dialog_menu : false,
        dialog_addon : false,
        headers:[ 
               { text: 'Date', value: 'date' , width: "20%"},           
              { text: 'Code', value: 'code' , width: "10%" },
              { text: 'Name', value: 'name' , width: "30%"},
              { text: '-', sortable: false , align: 'center', width: "5%"},
              { text: 'qty', value: 'qty' , align: 'center' , width: "10%"},                         
              { text: '+', sortable: false , align: 'center', width: "5%"},
              { text: 'Actions', value: 'actions', align: 'center', sortable: false , width: "20%"},              
            ],
        table_details:[],
        users: [],
        items_m:[],
        search: '',
        searchQuery : '',
        products :[],
        dialog_s: false,
        dialog_qty : false ,
        add_item_code : '',
        add_item_name : '',
        add_item_price : 0 ,
        add_freeitem : 0 ,
        qty_add : 1 ,
        total_point : 0 ,
        total_amount : 0 ,
        allergies : '' ,
        remark : '' ,
        deli_at : 'work' ,
        deli_add:'',
        deli_add_1:'',
        deli_add_2:'',
        mode: '',
        add_type : 0,
    }
  },
created () {
      console.log("CREATE")
      this.read_data()
      this.read_data_product()
      this.show_menu_add()
      this.get_address()
    },
computed:{
        resultQuery(){
            if(this.searchQuery){
            return this.products.filter((item)=>{
                return this.searchQuery.toLowerCase().split(' ').every(v => item.name.toLowerCase().includes(v))
            })
            }else{
                return this.products;
            }
        },
    },
  methods: {
      show_dialog(){
          this.dialog = true
      },
      hide_dialog(){
          this.dialog = false
      },
      hide_clear_dialog(){
          var date_clear = new Date().toISOString().substr(0, 10)
          this.date = date_clear
          this.dialog = false
      },
        read_data() {
            const vm = this;

            vm.axios.get('https://ws.plantifulbkk.shop/get_edit_branch_order.php',{
                params: {
                    scode: this.$store.getters.get_branch ,
                    sdate : this.$store.getters.get_date_branch_order ,
                }
            }).then(response => {
                var result = JSON.parse(JSON.stringify(response.data))
                vm.users = result
                console.log(result)
                let i = 0;
                vm.total_point = 0 
                vm.total_amount = 0 

                while (i < vm.users.length) {
                    if ( vm.users[i].price == 0 ){
                        if ( vm.users[i].freeitem == 0 ){
                            vm.total_point = vm.total_point + parseInt(vm.users[i].qty)
                        }
                    }else{
                        vm.total_amount = vm.total_amount + ( parseInt(vm.users[i].price) * parseInt(vm.users[i].qty) )
                    }    
                    ++i;
                }
            }).catch(function (error) {
                    alert("Error")
                    console.log(error)
            })

        },

        update_item( item  , type ){

            const updItem = this.users.find(p => p.code === item)                        
            if (updItem) {
                if ( type == 0 ){
                    if ( updItem.qty > 0  ){
                        updItem.qty = updItem.qty - 1                    
                    }
                }else{
                    updItem.qty = (updItem.qty*1) + 1 
                }                
            }
        },


        read_data_product() {
                const vm = this;
                vm.axios.get('https://ws.plantifulbkk.shop/get_product.php').then(response => {
                var result = JSON.parse(JSON.stringify(response.data))
                vm.products = result
                console.log(vm.products)
            }); 
        },
        del_prod( item ){
            const index =  this.users.find(p => p.code === item)     
            if (index !== -1) {
                this.users.splice(index, 1);
            }
        },
        btn_add(){  
            this.dialog_s = true
        },
        show_qty_input( code , name , price ){
            this.add_type = 0
            this.qty_add = 1
            this.add_item_code = code
            this.add_item_name = name
            this.add_item_price = price
            this.dialog_qty = true
        },
        show_qty_input_addon( code , name , price ){
            this.add_type = 2
            this.qty_add = 1
            this.add_item_code = code
            this.add_item_name = name
            this.add_item_price = price
            this.dialog_qty = true
        },        
        show_qty_input_menu( date , code , name , price , freeitem ){
            this.add_type = 1
            this.qty_add = 1
            this.date_menu = date
            this.add_item_code = code
            this.add_item_name = name
            this.add_item_price = price
            this.add_freeitem = freeitem
            this.dialog_qty = true
        },

        save_order(){

                const vm = this;
                vm.axios.get("https://ws.plantifulbkk.shop/post_save_edit_branchorder.php",{
                    params: {
                        sitem :JSON.stringify(this.users) ,
                        scode : this.$store.getters.get_branch ,
                        sdate : this.$store.getters.get_date_branch_order ,
                    }
                }).then(result=>{
                        console.log(result.data)
                        this.read_data()
                        this.$router.push('/branchorder')
                    })
                .catch(function (error) {
                        alert("Error")
                        console.log(error)
                    })

            },        

        show_menu_add(){
            const vm = this;
            vm.axios.get("https://ws.plantifulbkk.shop/get_weekday.php",{
                params: {
                            scode: ''
                        }
                    }).then(result=>{
                this.items_m = result.data
                console.log(' items menu = '+JSON.stringify( this.items_m  ))
            }) 

            vm.axios.get("https://ws.plantifulbkk.shop/get_weekday_adonn.php",{
                        params: {
                            
                        }
                    }).then(result=>{
            
              this.data_addon = result.data

            }) 


        },

        saveItem( code , name , qty , price ){

            const vm = this;
            let date_to_save
            let freeitem_to_save

            if ( this.add_type == 0 ){
                date_to_save = this.date 
                freeitem_to_save = 0
            }
            if ( this.add_type == 1 ){
                date_to_save = this.date_menu
                freeitem_to_save = this.add_freeitem
            }
            if ( this.add_type == 2 ){
                date_to_save = this.date 
                freeitem_to_save = 1
            }            

           this.users.push({"code":code,"date":date_to_save,"name":name,"price":price,"qty":qty})
            
            console.log(JSON.stringify(this.users ))

            this.dialog_qty = false 

       
        },
    },        

}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/pages/edit_branchorder.vue